import * as analytics from './analytics';
import { getCurrentBreakpoint } from './mediaBreakpoints';

export interface ITrackPageView {
  pathname: string;
  search: string;
}

export function trackPageView({ pathname, search }: ITrackPageView): void {
  analytics.trackEvent('page', 'view', 'page', {
    pathname,
    search,
    viewport: getCurrentBreakpoint(),
  });
}
